<template>
    <div class="container">
      <div class="row s_product_inner">
        <div class="col-lg-6">
          <img :src="product.image_url" class="d-block w-100" alt />
        </div>
        <div class="col-lg-5 offset-lg-1">
          <div class="s_product_text">
            <h3 class="h1">{{product.name}}</h3>
            <hr/>
            <h2>${{product.price}}</h2>
            <ul class="list m-4">
              <li>
                <a class="active" href="#">
                  <span>Category</span> : Health
                </a>
              </li>
              <li>
                <a href="#" :class="product.availability? 'text-success': 'text-danger'">
                  <span>Availibility</span> : {{product.availability? 'In Stock': 'Out of Stock'}}
                </a>
              </li>
            </ul>
              <Buy class="main_btn" :item="product" />
            <hr/>
            <div role="tablist">
              <b-card no-body class="mb-1">
                <b-card-header header-tag="header" class="p-1" role="tab">
                  <b-button block v-b-toggle.accordion-1 variant="default">
                    PRODUCT INFORMATION
                    <b-icon-dash class="when-opened"></b-icon-dash>
                    <b-icon-plus class="when-closed"></b-icon-plus>
                  </b-button>
                </b-card-header>
                <b-collapse id="accordion-1" visible accordion="my-accordion" role="tabpanel">
                  <b-card-body>
                    <ul class="unordered-list">
                      <li>SantizerWristband is built for functionality while on-the-go.</li>
                      <li>It is washable, rewearable and comes with two caps, one for loose liquids and the other for liquid gels.</li>
                      <li>Holds up to 15mL of liquids and is easy to refill.</li>
                      <li>Fill with your liquid of choice and press on the wristband to dispense at your leisure.</li>
                      <li>The band is ideal for those who travel, work in health care, service industries and just about anyone else.</li>
                      <li>Makes the perfect gift for yourself and loved ones</li>
                    </ul>
                  </b-card-body>
                </b-collapse>
              </b-card>

              <b-card no-body class="mb-1">
                <b-card-header header-tag="header" class="p-1" role="tab">
                  <b-button block v-b-toggle.accordion-2 variant="default">
                    RETURN POLICY
                    <b-icon-dash class="when-opened"></b-icon-dash>
                    <b-icon-plus class="when-closed"></b-icon-plus>
                  </b-button>
                </b-card-header>
                <b-collapse id="accordion-2" accordion="my-accordion" role="tabpanel">
                  <b-card-body>
                    <b-card-text>
                      Due to the nature of our product, we do not accept refunds or exchanges.
                      However, if your product is received defective (and unused)
                      we are willing to exchange it for you at no extra charge.
                      If this happens, please email us directly at <a href="mailto:info@sanitizerwristband.com">info@sanitizerwristband.com</a></b-card-text>
                  </b-card-body>
                </b-collapse>
              </b-card>

              <b-card no-body class="mb-1">
                <b-card-header header-tag="header" class="p-1" role="tab">
                  <b-button block v-b-toggle.accordion-3 variant="default">
                    SHIPPING INFORMATION
                    <b-icon-dash class="when-opened"></b-icon-dash>
                    <b-icon-plus class="when-closed"></b-icon-plus>
                  </b-button>
                </b-card-header>
                <b-collapse id="accordion-3" accordion="my-accordion" role="tabpanel">
                  <b-card-body></b-card-body>
                </b-collapse>
              </b-card>
            </div>
            <div class="card_area">
            </div>
          </div>
        </div>
      </div>
    </div>
</template>
<script>
import Buy from '@/components/BuyButton'
export default {
  components: {
    Buy
  },
  props: ['product']
}
</script>
<style scoped>
.s_product_text > .card_area > a {
outline: none;
    line-height: 40px;
    padding:10px;
    font-size: .8em;
    text-align: center;
    text-decoration: none;
    font-weight: 500;
    border-radius: 20px;
    width:70px;
    cursor: pointer;
        margin-right: 10px;
    margin-top: 10px;
    border-color: 1px solid #797979;
}
.collapsed > .when-opened,
:not(.collapsed) > .when-closed {
    display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/ProductDetails.vue